import React from 'react'
import classes from "./Pricing.module.css";
import promix from "../../Assets/Promix.svg"
import marked from "../../Assets/marked.svg"
import star from "../../Assets/star.svg"
import { Link } from 'react-router';

const Pricing = () => {
    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>
                Choose Your Perfect Plan
            </div>

            <p className={classes.ship}>Start with our free plan and upgrade as your business grows. All plans<br />
                include our core features.
            </p>

            <div className={classes.medor}>
                <div className={classes.mentorship}>
                    <p className={classes.patriot}>Starter</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>₦0</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>Perfect for freelancers and solo
                        entrepreneurs
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            <div className={classes.manga2}>
                                <img src={marked} />
                                <p className={classes.peter}>1 User</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Basic Reporting</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Bank Sync</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Mobile App</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Email Support</p>
                            </div>

                            <Link to="/modules"><button className={classes.negate}>Start Free</button></Link>
                        </div>
                    </div>

                </div>



                <div className={classes.mentorship2}>
                    <div className={classes.popular}>
                        <img src={star}/>
                        <p>Most Popular</p>
                    </div>
                    <p className={classes.patriot}>Professional</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>₦25,000</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>Ideal for growing businesses and small
                        teams
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            <div className={classes.manga2}>
                                <img src={marked} />
                                <p className={classes.peter}>5 User</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Advanced Reports</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Multi-currency</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>API Access</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Priority Support</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Custom Integrations</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Automated Workflows</p>
                            </div>

                            <Link to="/modules"><button className={classes.negate2}>Choose plan</button></Link>
                        </div>
                    </div>

                </div>



                <div className={classes.mentorship}>
                    <p className={classes.patriot}>Enterprise</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>₦50,000</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <p className={classes.mogurn}>For established businesses with complex
                        needs
                    </p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            <div className={classes.manga2}>
                                <img src={marked} />
                                <p className={classes.peter}>Unlimited Users</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>White-label Options</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Advanced Security</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}>Dedicated Manager</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Custom Training</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> SLA Guarantee</p>
                            </div>
                            <div className={classes.manga}>
                                <img src={marked} />
                                <p className={classes.peter}> Custom Integrations</p>
                            </div>

                            <Link to="/modules"><button className={classes.negate}>Choose Plan</button></Link>
                        </div>
                    </div>

                </div>

            </div>

            <p className={classes.proeterw}>Trusted by 10,000+ businesses worldwide</p>
            <div className={classes.pitfall}>
                <div className={classes.number_num}>
                    <p className={classes.costat}>₦50B+</p>
                    <p className={classes.prethelr}>Processed Monthly</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>99.9%</p>
                    <p className={classes.prethelr}> Uptime SLA</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>500+</p>
                    <p className={classes.prethelr}>Integrations</p>
                </div>
            </div>
        </div>

    )
}

export default Pricing
